/* Pete's Recipes — interactive layer for the recipe page.
 * Portion scaling, timers, save/rate (localStorage), share, print,
 * shopping list, cook mode, nutrition scaling. Self-contained per page.
 */
(function () {
  var root = document.querySelector('[data-recipe]');
  if (!root) return;

  var recipeId = (document.title || 'recipe').replace(/\s+/g, '-').toLowerCase();
  var baseServings = parseFloat(root.dataset.baseServings) || 1;

  // localStorage can throw in private/blocked-storage contexts — never let that kill a handler.
  function storageSet(key, value) {
    try { localStorage.setItem(key, value); return true; } catch (e) { return false; }
  }

  /* ---------- helpers ---------- */
  function toast(msg) {
    var t = document.querySelector('.recipe-toast') || (function () {
      var el = document.createElement('div'); el.className = 'recipe-toast'; document.body.appendChild(el); return el;
    })();
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  // Parse a quantity string ("1/2 cup", "2-4 oz", "8 oz", "1 1/2 tbsp") → scale the leading number(s).
  function scaleQty(raw, mult) {
    if (!raw) return raw;
    // match leading number group: ranges (2-4), mixed (1 1/2), fractions (1/2), decimals (0.5)
    var m = raw.match(/^\s*(\d+(?:\.\d+)?(?:\s+\d+\/\d+)?(?:\/\d+)?(?:\s*-\s*\d+(?:\.\d+)?(?:\/\d+)?)?)/);
    if (!m) return raw;
    var numStr = m[1];
    var rest = raw.slice(m[0].length);
    var scaledNum = numStr.replace(/\d+(?:\s+\d+\/\d+)?(?:\.\d+)?(?:\/\d+)?/g, function (token) {
      var val = parseMixed(token) * mult;
      return formatNum(val);
    });
    return scaledNum + rest;
  }
  function parseMixed(tok) {
    tok = tok.trim();
    if (tok.indexOf(' ') > -1) { var p = tok.split(' '); return parseFloat(p[0]) + parseFrac(p[1]); }
    if (tok.indexOf('/') > -1) return parseFrac(tok);
    return parseFloat(tok);
  }
  function parseFrac(f) { var p = f.split('/'); return parseFloat(p[0]) / parseFloat(p[1]); }
  function formatNum(v) {
    if (Math.abs(v - Math.round(v)) < 0.01) return String(Math.round(v));
    // nearest common fraction
    var fracs = [[0.25, '¼'], [0.33, '⅓'], [0.5, '½'], [0.66, '⅔'], [0.75, '¾']];
    var whole = Math.floor(v); var dec = v - whole;
    for (var i = 0; i < fracs.length; i++) {
      if (Math.abs(dec - fracs[i][0]) < 0.06) return (whole ? whole + ' ' : '') + fracs[i][1];
    }
    return (Math.round(v * 100) / 100).toString();
  }

  /* ---------- portion scaler ---------- */
  var currentMult = 1;
  var qtyEls = root.querySelectorAll('[data-recipe-qty]');
  var servingsEl = root.querySelector('[data-recipe-servings]');
  root.querySelectorAll('[data-recipe-scale]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      currentMult = parseFloat(btn.dataset.recipeScale);
      root.querySelectorAll('[data-recipe-scale]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      qtyEls.forEach(function (q) { q.textContent = scaleQty(q.dataset.base, currentMult); });
      if (servingsEl) servingsEl.textContent = formatNum(baseServings * currentMult);
      scaleNutrition(currentMult);
    });
  });

  /* ---------- nutrition scaling (label shows per-serving, so multiplier=1 keeps per-serving) ---------- */
  function scaleNutrition() { /* label is per-serving; intentionally not multiplied. Hook kept for future total view. */ }

  /* ---------- print: render a clean recipe into a hidden iframe (robust incl. iOS Safari) ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var PRINT_CSS =
    'body{margin:0;padding:24px;color:#000;background:#fff;font:14px/1.5 -apple-system,BlinkMacSystemFont,Arial,sans-serif;}' +
    'h1{font:700 26px/1.1 Georgia,serif;margin:0 0 8px;}' +
    'h2{font:700 18px/1.2 Georgia,serif;margin:18px 0 6px;}' +
    '.facts,.meta{font-size:12px;margin:0 0 6px;}ul,ol{margin:0;padding-left:20px;}li{padding:3px 0;}';
  function buildRecipeHTML() {
    var title = (root.querySelector('.recipe__title') || {}).textContent || document.title;
    var h = '<h1>' + esc(title.trim()) + '</h1>';
    var facts = [].map.call(root.querySelectorAll('.recipe__facts .recipe__translation'), function (p) { return esc(p.textContent.trim()); });
    if (facts.length) h += '<p class="facts">' + facts.join(' &middot; ') + '</p>';
    var meta = [].map.call(root.querySelectorAll('.recipe__meta-item'), function (it) {
      return esc(((it.querySelector('.recipe__meta-label') || {}).textContent || '').trim()) + ': ' + esc(((it.querySelector('strong') || {}).textContent || '').trim());
    });
    if (meta.length) h += '<p class="meta">' + meta.join(' &nbsp;|&nbsp; ') + '</p>';
    h += '<h2>Ingredients</h2><ul>';
    root.querySelectorAll('.recipe__ingredient').forEach(function (li) {
      var q = ((li.querySelector('[data-recipe-qty]') || {}).textContent || '').trim();
      var n = ((li.querySelector('.recipe__ingredient-name') || {}).textContent || '').trim();
      h += '<li>' + (q ? '<strong>' + esc(q) + '</strong> ' : '') + esc(n) + '</li>';
    });
    h += '</ul><h2>Instructions</h2><ol>';
    root.querySelectorAll('.recipe__step p').forEach(function (p) { h += '<li>' + esc(p.textContent.trim()) + '</li>'; });
    return h + '</ol>';
  }
  var printBtn = root.querySelector('[data-recipe-print]');
  if (printBtn) printBtn.addEventListener('click', function () {
    var frame = document.getElementById('recipe-print-frame');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.id = 'recipe-print-frame';
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;'; // 0x0, reused, never removed
      document.body.appendChild(frame);
    }
    var title = (root.querySelector('.recipe__title') || {}).textContent || 'Recipe';
    var d = frame.contentWindow.document;
    d.open();
    d.write('<!doctype html><html><head><meta charset="utf-8"><title>' + esc(title.trim()) + '</title><style>' + PRINT_CSS + '</style></head><body>' + buildRecipeHTML() + '</body></html>');
    d.close();
    setTimeout(function () { try { frame.contentWindow.focus(); frame.contentWindow.print(); } catch (e) {} }, 80);
  });

  /* ---------- share ---------- */
  var shareBtn = root.querySelector('[data-recipe-share]');
  if (shareBtn) shareBtn.addEventListener('click', function () {
    var data = { title: document.title, url: window.location.href };
    if (navigator.share) { navigator.share(data).catch(function () {}); }
    else { navigator.clipboard && navigator.clipboard.writeText(window.location.href); toast('Link copied!'); }
  });

  /* ---------- shopping list ---------- */
  var shopBtn = root.querySelector('[data-recipe-shopping]');
  if (shopBtn) shopBtn.addEventListener('click', function () {
    var items = [];
    var recipeTitleEl = root.querySelector('.recipe__title');
    var recipeTitle = recipeTitleEl ? recipeTitleEl.textContent.trim() : document.title;
    root.querySelectorAll('.recipe__ingredient').forEach(function (li) {
      var cb = li.querySelector('[data-recipe-ingredient-check]');
      if (cb && cb.checked) {
        var qtyEl = li.querySelector('[data-recipe-qty]');
        var nameEl = li.querySelector('.recipe__ingredient-name');
        var qty = qtyEl ? qtyEl.textContent.trim() : '';
        var name = nameEl ? nameEl.textContent.trim() : '';
        if (name) {
          items.push({
            id: String(new Date().getTime()) + '-' + String(Math.random()).slice(2),
            qty: qty,
            name: name,
            recipe: recipeTitle || 'Recipe',
            done: false
          });
        }
      }
    });
    if (!items.length) { toast('Check some ingredients first'); return; }
    var KEY = 'petes_shopping_list';
    var list; try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    list = list.concat(items);
    storageSet(KEY, JSON.stringify(list));
    toast(items.length + ' added to shopping list');
    if (window.petesShoppingListRefresh) window.petesShoppingListRefresh();
  });

  /* ---------- generic timer (user sets minutes) ---------- */
  var timerBtn = root.querySelector('[data-recipe-timer]');
  if (timerBtn) {
    var timerText = timerBtn.querySelector('[data-timer-text]') || timerBtn;
    var timerInput = root.querySelector('[data-timer-minutes]');
    var remaining = 0, interval = null;
    function stopTimer(msg) {
      clearInterval(interval); interval = null;
      timerBtn.classList.remove('is-running');
      timerText.textContent = 'Start timer';
      if (timerInput) timerInput.disabled = false;
      if (msg) { toast(msg); try { new Audio('data:audio/wav;base64,UklGRl9vT19XQVZF').play(); } catch (e) {} }
    }
    timerBtn.addEventListener('click', function () {
      if (interval) { stopTimer(); return; }
      var mins = parseInt(timerInput && timerInput.value, 10);
      if (!mins || mins < 1) mins = 10;
      remaining = mins * 60;
      timerBtn.classList.add('is-running');
      if (timerInput) timerInput.disabled = true;
      function render() { var m = Math.floor(remaining / 60), s = remaining % 60; timerText.textContent = m + ':' + (s < 10 ? '0' : '') + s; }
      render();
      interval = setInterval(function () {
        remaining--;
        if (remaining < 0) { stopTimer('Timer done! ⏰'); return; }
        render();
      }, 1000);
    });
  }

  /* ---------- cook mode (full screen + wake lock) ---------- */
  var cookBtn = root.querySelector('[data-recipe-cookmode]');
  var steps = Array.prototype.map.call(root.querySelectorAll('[data-recipe-step] p'), function (p) { return p.textContent; });
  if (cookBtn && steps.length) {
    var overlay = document.createElement('div');
    overlay.className = 'recipe-cookmode';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Cook mode');
    overlay.innerHTML = '<button class="recipe-cookmode__close" aria-label="Close">×</button>' +
      '<div class="recipe-cookmode__count" aria-live="polite"></div><div class="recipe-cookmode__step"></div>' +
      '<div class="recipe-cookmode__nav"><button class="recipe-cookmode__btn" data-cm-prev>← Back</button><button class="recipe-cookmode__btn recipe-cookmode__btn--primary" data-cm-next>Next →</button></div>';
    document.body.appendChild(overlay);
    var idx = 0, wakeLock = null, cmReturnFocus = null;
    var countEl = overlay.querySelector('.recipe-cookmode__count');
    var stepEl = overlay.querySelector('.recipe-cookmode__step');
    function renderCM() { countEl.textContent = 'Step ' + (idx + 1) + ' of ' + steps.length; stepEl.textContent = steps[idx]; }
    function openCM() {
      idx = 0; renderCM(); overlay.classList.add('is-open'); document.body.classList.add('recipe-cookmode-on');
      cmReturnFocus = document.activeElement;
      overlay.querySelector('[data-cm-next]').focus();
      if (navigator.wakeLock) navigator.wakeLock.request('screen').then(function (w) { wakeLock = w; }).catch(function () {});
    }
    function closeCM() {
      overlay.classList.remove('is-open'); document.body.classList.remove('recipe-cookmode-on');
      if (wakeLock) { wakeLock.release(); wakeLock = null; }
      if (cmReturnFocus && cmReturnFocus.focus) { cmReturnFocus.focus(); cmReturnFocus = null; }
    }
    cookBtn.addEventListener('click', openCM);
    overlay.querySelector('.recipe-cookmode__close').addEventListener('click', closeCM);
    overlay.querySelector('[data-cm-next]').addEventListener('click', function () { if (idx < steps.length - 1) { idx++; renderCM(); } else closeCM(); });
    overlay.querySelector('[data-cm-prev]').addEventListener('click', function () { if (idx > 0) { idx--; renderCM(); } });
    document.addEventListener('keydown', function (e) { if (!overlay.classList.contains('is-open')) return; if (e.key === 'Escape') closeCM(); if (e.key === 'ArrowRight') overlay.querySelector('[data-cm-next]').click(); if (e.key === 'ArrowLeft') overlay.querySelector('[data-cm-prev]').click(); });
  }
})();
